import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=265efa56&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=265efa56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265efa56",
  null
  
)

export default component.exports